import type { FC } from 'react';
import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons';

import formatKpiValue from '../../../utils/formatKpiValue';
import type { DeltaColors } from '../../../config/scenarioComparisonConfig';

interface DeltaIndicatorProps {
    delta: number | null;
    isPercent?: boolean;
    colors: DeltaColors;
}

const DeltaIndicator: FC<DeltaIndicatorProps> = ({ delta, isPercent, colors }) => {
    if (delta == null || delta === 0) return null;

    const isPositive = delta > 0;

    return (
        <span
            className="flex items-center gap-0.5 text-xs"
            style={{ color: isPositive ? colors.positive : colors.negative }}
        >
            {isPositive ? (
                <CaretUpFilled className="text-[10px]" />
            ) : (
                <CaretDownFilled className="text-[10px]" />
            )}
            {formatKpiValue(Math.abs(delta), isPercent ? 'percent' : undefined)}
        </span>
    );
};

DeltaIndicator.displayName = 'DeltaIndicator';
export default DeltaIndicator;
